import { useState } from "react";
import CloseIcon from "../../assets/icons/close.svg";

import "../../utils/styles/modal.css";
import "./ModalAddSocial.css";
import { contentService } from "../../services/content.service";
import { closeModal, showModal } from "../../utils/functions/modal";
import { DEFAULT_SOCIAL_ICON, socialIcons } from "../../utils/functions/socials";

const ModalAddSocial = ({ setMessage, onSuccess }) => {
  const [nombre, setNombre] = useState("");
  const [url, setUrl] = useState("");
  const [icono, setIcono] = useState(DEFAULT_SOCIAL_ICON);
  const [orden, setOrden] = useState(0);

  const clearInputs = () => {
    setNombre("");
    setUrl("");
    setIcono(DEFAULT_SOCIAL_ICON);
    setOrden(0);
  };

  const handleSubmitSocial = async (e) => {
    e.preventDefault();

    closeModal(".container-modal-add-social");
    showModal(".container-modal-confirm");
    setMessage({
      description: "Agregando red social...",
      status: 1000,
    });

    const response = await contentService.addSocial({
      nombre: nombre.trim(),
      url: url.trim(),
      icono,
      orden: parseInt(orden) || 0,
    });

    setTimeout(() => {
      if (response.data.status === 200) {
        clearInputs();
        onSuccess?.();
      }
      setMessage({
        description: response.data.message,
        status: response.data.status,
      });
    }, 1000);
  };

  return (
    <div className="container-modal container-modal-add-social">
      <div className="modal modal-add-social">
        <div className="header-modal">
          <h3>Agregar Red Social</h3>
          <button onClick={() => closeModal(".container-modal-add-social")}>
            <img src={CloseIcon} alt="" />
          </button>
        </div>
        <form onSubmit={handleSubmitSocial} className="body-modal">
          <div className="input">
            <label htmlFor="nombreAddSocial">Nombre</label>
            <input
              type="text"
              id="nombreAddSocial"
              name="nombreAddSocial"
              required
              onChange={(e) => setNombre(e.target.value)}
              value={nombre}
              placeholder="Instagram"
            />
          </div>
          <div className="input">
            <label htmlFor="urlAddSocial">Link</label>
            <input
              type="url"
              id="urlAddSocial"
              name="urlAddSocial"
              required
              onChange={(e) => setUrl(e.target.value)}
              value={url}
              placeholder="https://www.instagram.com/colibri_premium/"
            />
            <span className="hint">Tiene que empezar con http:// o https://</span>
          </div>
          <div className="input">
            <label htmlFor="iconoAddSocial">Icono</label>
            <select
              id="iconoAddSocial"
              name="iconoAddSocial"
              onChange={(e) => setIcono(e.target.value)}
              value={icono}
            >
              {Object.entries(socialIcons).map(([slug, { label }]) => (
                <option key={slug} value={slug}>
                  {label}
                </option>
              ))}
            </select>
            <span className="hint">Es el que se muestra en el footer de la web</span>
          </div>
          <div className="input">
            <label htmlFor="ordenAddSocial">Orden</label>
            <input
              type="number"
              id="ordenAddSocial"
              name="ordenAddSocial"
              onChange={(e) => setOrden(e.target.value)}
              value={orden}
              min={0}
            />
            <span className="hint">Determina el orden en que se muestra en el footer (menor primero)</span>
          </div>

          <button className="btn-add-product">AGREGAR RED SOCIAL</button>
        </form>
      </div>
    </div>
  );
};

export default ModalAddSocial;
